import { AccountReceivableInstallment } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { useDocumentTypeMutation } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.hooks';
import { MathRound } from '@/utils/functions/MathRound';
import { DocumentType } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.types';
import { useQueryClient } from 'react-query';

interface PropsInstallment {
  installmentValue: number;
  discountIncrease: number;
  installmentReceivables?: AccountReceivableInstallment[];
  currentInstallment: number;
  documentTypeId?: number;
  isEdit?: boolean;
  installmentQuantity?: number;
}

const useGetInstallmentRate = () => {
  const { mutateAsync: documentTypeMutate } = useDocumentTypeMutation();
  const query = useQueryClient()
    .getMutationCache()
    .find({ mutationKey: 'documentType' });

  return async (params: PropsInstallment) => {
    let tariff = 0;

    let documentType: DocumentType | undefined;
    const queryDocumentType = query?.state.data as DocumentType | undefined;

    if (params.documentTypeId) {
      if (queryDocumentType && queryDocumentType.id === params.documentTypeId) {
        documentType = query?.state.data as DocumentType;
      } else {
        const newMutation = await documentTypeMutate(params.documentTypeId);
        query?.setState({
          ...query.state,
          data: newMutation,
        });
        documentType = newMutation;
      }
    }

    if (documentType) {
      if (documentType.fixedRate) {
        tariff = MathRound(
          (documentType.percentRate / 100) *
            (params.installmentValue + (params.discountIncrease ?? 0)),
          2,
        );
      } else if (documentType.rates.length) {
        if (typeof params.installmentQuantity === 'number') {
          const rate = documentType.rates.find(
            (rate) => rate.numberInstallments === params.installmentQuantity,
          );

          tariff =
            ((rate?.percentRate ?? 0) / 100) *
            (params.installmentValue + (params.discountIncrease ?? 0));
        }
      }
    }

    return tariff;
  };
};

export default useGetInstallmentRate;
